import { Controller } from "@hotwired/stimulus"
import { Sortable, MultiDrag } from 'sortablejs'
import { patch } from '@rails/request.js'

Sortable.mount(new MultiDrag())

// Connects to data-controller="sortable"
export default class extends Controller {
  static values = { 
    cohortId: String,
    type: { type: String, default: 'node' }  // 'node' or 'segment', defaults to 'node'
  }

  connect() {
    this.sortable = Sortable.create(this.element, {
      group: 'shared',
      onEnd: this.saveChanges.bind(this),
      animation: 150,
      ghostClass: '!bg-gray-200',
      sort: false,
      multiDrag: true,
      selectedClass: "!border-indigo-500",
    })
  }

  saveChanges(event) {
    const units = [...new Set([event.item, ...event.items])]
    const targetCohortId = event.to.dataset.sortableCohortIdValue
    const sourceCohortId = event.from.dataset.sortableCohortIdValue

    units.forEach(unit => {
      // Only update if the unit moved to a different container
      if (sourceCohortId !== targetCohortId) {
        this.updateUnit(unit.dataset.sortableUpdateUrlValue, targetCohortId)
      }
    })
  }

  async updateUnit(updateUrl, targetCohortId) {
    // Build the body based on the type value
    const paramName = this.typeValue === 'segment' ? 'segment_id' : 'node_id'
    const body = { [paramName]: targetCohortId }

    await patch(updateUrl, {
      contentType: "application/json",
      responseKind: "json",
      body: body
    })
  }
}
